import NavItem from "../NavItem";
import walletIcon from "../../../../../../assets/icons/wallet.svg";

const WalletNavItem = () => {
  return (
    <NavItem>
      <img src={walletIcon} alt="wallet" />
      <span>رصيدي</span>
    </NavItem>
  );
};

export default WalletNavItem;
